var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "vue-custom-scrollbar",
        { on: { "ps-y-reach-end": _vm.scrollReachEnd } },
        [
          _c(
            "div",
            {
              staticClass:
                "ap-workspace-table-container workspace-admin-scroll-part"
            },
            [
              _c("table", { staticClass: "result-table" }, [
                _c("thead", [
                  _c("tr", { staticClass: "head-tr" }, [
                    _c("th", [_vm._v("№")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Дата поступления")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Заказчик")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Город заказчика")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Изображение")]),
                    _vm._v(" "),
                    _c("th", { staticClass: "field-edit" }, [_vm._v("Опции")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.incoming, function(value, index) {
                    return _c("tr", { staticClass: "body-tr row" }, [
                      _c("td", [
                        _c("span", { staticClass: "table-data" }, [
                          _vm._v(_vm._s(index + 1))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "table-data" }, [
                          _vm._v(_vm._s(_vm.dateIntoRu(value.create_date)))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(value.customers, function(customer) {
                          return _c("span", { staticClass: "table-data" }, [
                            _vm._v(_vm._s(customer.name))
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(value.customers, function(customer) {
                          return _c("span", { staticClass: "table-data" }, [
                            _vm._v(_vm._s(customer.city))
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("img", {
                          staticClass: "ap-table-img",
                          attrs: {
                            src: _vm.getFirstImg(value.data_json.photoList)
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "edit-button-group" }, [
                          _c(
                            "div",
                            {
                              staticClass: "table-svg-button",
                              on: {
                                click: function($event) {
                                  return _vm.selectUser(value.guid)
                                }
                              }
                            },
                            [_c("SVGUserTag")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "table-svg-button",
                              on: {
                                click: function($event) {
                                  return _vm.confirm(value)
                                }
                              }
                            },
                            [_c("SVGAdminDeleteRow")],
                            1
                          )
                        ])
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _vm.waitingResponseToIncomingRequest
                ? _c(
                    "div",
                    { staticClass: "ap-loader-grid" },
                    [
                      _c("SpinnerTwo"),
                      _vm._v(" "),
                      _c("div", { staticClass: "ap-loader-text" }, [
                        _vm._v(
                          "\n                        Идет загрузка заявок ...\n                    "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ap-workspace-head" }, [
      _c("div", { staticClass: "ap-workspace-label" }, [
        _c("div", { staticClass: "ap-workspace-label-name" }, [
          _vm._v(
            "\n                    Заявки на визуализацию\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ap-workspace-label-btn ap-add-left-margin" }, [
        _c("label", { staticClass: "ap-search" }, [
          _c("input", {
            staticClass: "ap-search-input",
            attrs: { type: "text", placeholder: "Найти заявку" }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }